import {
    ADDITIONAL_CMS_SITE_STRUCTURE,
    CLASS_FIRST_STEP,
    CLASS_SECOND_STEP,
    ID_PHONE_NUMBER_INPUT,
    ID_SMS_INPUT,
    TRACKING_NOT_LOGGED_IN,
    TRACKING_SITE_STATES,
} from '../constant';
import {
    BtxType,
    IComponents,
    StepNumber,
} from '../interfaces/main.interface';
import { trackIt } from '@vfde-sails/tracking';
import { getTrackingPayload } from './tracking.helper';
import { AppActionDispatchers } from '../action';
import { FormElement } from '@vfde-brix/ws10/form-element';
import { CLASSNAME_HIDDEN } from '@vfde-brix/ws10/styles';

/**
 * Accepted step numbers are 0 and 1, this way the function is simplified
 * !0 = true, !1 = false
 * !!0 = false, !!1 = true
 */
export const manageSteps = (
    stepNumber: StepNumber,
    btx: BtxType,
    components: IComponents | null,
    setError: AppActionDispatchers['setError'],
) => {
    stepNumber === 1 && setError(null);
    const firstStepElements = Array.from(document.getElementsByClassName(CLASS_FIRST_STEP));
    const secondStepElements = Array.from(document.getElementsByClassName(CLASS_SECOND_STEP));

    const siteStructureForTracking = [...ADDITIONAL_CMS_SITE_STRUCTURE, btx, TRACKING_SITE_STATES[stepNumber]];
    trackIt('pageview', getTrackingPayload(siteStructureForTracking, TRACKING_NOT_LOGGED_IN));

    firstStepElements.forEach(element => element.classList.toggle(CLASSNAME_HIDDEN, stepNumber === 1));
    secondStepElements.forEach(element => element.classList.toggle(CLASSNAME_HIDDEN, stepNumber === 0));

    const { phoneInputComponent } = components || {};
    phoneInputComponent && updatePhoneInputComponent(phoneInputComponent, stepNumber);
    updateSmsInputComponent(stepNumber);
};

/**
 * update phone component on step change
 */
export const updatePhoneInputComponent = (phoneInputComponent: FormElement, stepNumber: StepNumber): void => {
    const phoneinput = document.getElementById(ID_PHONE_NUMBER_INPUT) as HTMLInputElement;
    const phoneNumber = phoneinput?.value;
    const newProps = phoneInputComponent.getProperties();
    newProps.optDisabled = stepNumber === 1;
    newProps.stdValue = stepNumber === 1 ? phoneNumber : '';
    phoneInputComponent.update(newProps);

    if (stepNumber === 0) {
        // have to reuse the reference since the form element stdvalue is not functioning...
        (<HTMLInputElement>document.getElementById(ID_PHONE_NUMBER_INPUT)).focus();
    }
};

/**
 * update sms component on step change
 */
export const updateSmsInputComponent = (stepNumber: StepNumber) => {
    const smsinput = document.getElementById(ID_SMS_INPUT) as HTMLInputElement;
    // formelement props are always empty regardless the html so we have to do it the old school way...
    smsinput.value = '';

    if (stepNumber === 1) {
        smsinput?.focus();
    }
};
